import {
  createFeatureMap,
  getFeatureLabel
} from '@/lib/utils/feature-library'
import {
  FeatureLibraryItem,
  FeaturesLibrarySection,
} from '@/types/cxp-solution-page'
import { useLocale } from 'next-intl'
import { useMemo } from 'react'

interface UseFeatureLibraryProps {
  featuresLibrary?: FeaturesLibrarySection
}

export function useFeatureLibrary(props?: UseFeatureLibraryProps) {
  const locale = useLocale()
  const featuresLibrary = props?.featuresLibrary

  const featureMap = useMemo(() => {
    return createFeatureMap(featuresLibrary)
  }, [featuresLibrary])

  const getFeature = (id: string) => {
    return featureMap.get(id) || null
  }

  const getLabel = (feature: FeatureLibraryItem) => {
    return getFeatureLabel(feature, locale)
  }

  const getFeatureAndLabel = (id: string) => {
    const feature = getFeature(id)
    if (!feature) return null
    return {
      feature,
      label: getLabel(feature),
    }
  }

  return {
    featuresLibrary,
    featureMap,
    getFeature,
    getLabel,
    getFeatureAndLabel,
    locale,
  }
}
